import { createRouter, createWebHistory } from "vue-router";
import App from "./App.vue";
import store from "./store";

const routes = [
  {
    path: "/dashboard",
    name: "app",
    component: App,
    meta: { requiresAuth: true }, // Menandakan bahwa rute ini memerlukan autentikasi
    children: [
      {
        path: "",
        name: "dashboard",
        component: () => import("./pages/Dashboard.vue"),
      },
      {
        path: "/dashboard-gt",
        name: "dashboard-gt",
        component: () => import("./pages/DashboardGT.vue"),
      },
      {
        path: "/dashboard-mti",
        name: "dashboard-mti",
        component: () => import("./pages/DashboardMTI.vue"),
      },
      {
        path: "/user-app",
        name: "user-app",
        component: () => import("./pages/master/UserApp.vue"),
      },
      {
        path: "/user-web",
        name: "user-web",
        component: () => import("./pages/master/UserWeb.vue"),
      },
      {
        path: "/report-visit-gt",
        name: "report-visit-gt",
        component: () => import("./pages/report/VisitGT.vue"),
      },
      {
        path: "/report-visit-mti",
        name: "report-visit-mti",
        component: () => import("./pages/report/VisitMTI.vue"),
      },
      {
        path: "/report-mitra-availability",
        name: "report-mitra-availability",
        component: () => import("./pages/report/MitraAvailability.vue"),
      },
      {
        path: "/report-spreading-order",
        name: "report-spreading-order",
        component: () => import("./pages/report/SpreadingOrder.vue"),
      },
      {
        path: "/report-avis-npl",
        name: "report-avis-npl",
        component: () => import("./pages/report/AvisNpl.vue"),
      },
      {
        path: "/report-existing",
        name: "report-existing",
        component: () => import("./pages/report/Existing.vue"),
      },
      {
        path: "/report-npl",
        name: "report-npl",
        component: () => import("./pages/report/Npl.vue"),
      },
      {
        path: "/report-het-kompetitor",
        name: "report-het-kompetitor",
        component: () => import("./pages/report/HetKompetitor.vue"),
      },
      {
        path: "/report-non-ec-reason",
        name: "report-non-ec-reason",
        component: () => import("./pages/report/NonEcReason.vue"),
      },
      {
        path: "/report-competitor-availability",
        name: "report-competitor-availability",
        component: () => import("./pages/report/CompetitorAvailability.vue"),
      },
      {
        path: "/example-page",
        name: "example-page",
        component: () => import("./pages/ExamplePage.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./pages/Login.vue"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("./pages/Error.vue"),
  },
  {
    path: "/access",
    name: "access",
    component: () => import("./pages/Access.vue"),
  },
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: () => import("./pages/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("authToken");
  const pageName = to.name;

  if (to.name === "login" && isAuthenticated) {
    next({ name: "dashboard" });
  } else {
    // Mengecek apakah rute saat ini memiliki children
    if (to.matched.some((route) => route.meta.requiresAuth)) {
      // Jika pengguna telah login, lanjutkan ke rute yang diminta
      if (isAuthenticated) {
        store.dispatch("auth/checkPermission", pageName);
        setTimeout(() => {
          if (localStorage.getItem("isPermission") == "false") {
            next({ name: "access" });
          } else {
            next();
          }
        }, 250);
      } else {
        // Jika pengguna belum login, redirect ke halaman login
        next({ name: "login" });
      }
    } else {
      // Jika rute tidak memiliki children, lanjutkan ke rute yang diminta
      next();
    }
  }
});
export default router;
